import BarChartCustom from "@components/BarChart";
import NoData from "@components/NoData";
import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";
import { CircularProgress, Grid } from "@material-ui/core";
import { IChartDataService } from "@modules/financial/models/IChartDataService";
import { useFinancialDashboardContext } from "@pages/Financial/FinancialDashboard/FinancialDashboardContext";
import { IFinancialDashboardChartQuery } from "@pages/Financial/FinancialInstallments/interface";
import { formatCurrency, formatDecimal } from "@utils/index";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";

const AdvisorChart: React.FC<{
  filters: IFinancialDashboardChartQuery;
}> = ({ filters }) => {
  const iocContext = useIoCContext();

  const getChartService = iocContext.serviceContainer.get<IChartDataService>(
    Types.Financial.IChartDataService
  );

  const [series, setSeries] = useState<
    ApexAxisChartSeries | ApexNonAxisChartSeries
  >([-1]);

  const { query, loaders, setLoaders } = useFinancialDashboardContext();
  const { enqueueSnackbar } = useSnackbar();

  const getChartAdvisor = useCallback(async () => {
    try {
      setLoaders((state) => ({
        ...state,
        isAdvisorChartLoading: true,
      }));
      const queryResult = await getChartService.getAdvisorChart({
        ...filters,
        from: query.from,
        to: query.to,
      });
      let rows = queryResult.rows.filter((item) =>
        item.every((value) => value != null)
      );

      const data = rows.slice(0, 10).map((item) => {
        let xList = item[1]?.split(" ") ?? [];
        return {
          x: xList.slice(0, 1),
          y: item[2],
        };
      });

      setSeries([{ data }]);
    } catch (error) {
      enqueueSnackbar(
        "Ocorreu um erro ao carregar gráfico de partidas vencidas!",
        {
          variant: "error",
        }
      );
    } finally {
      setLoaders((state) => ({
        ...state,
        isAdvisorChartLoading: false,
      }));
    }
  }, [
    enqueueSnackbar,
    filters,
    setLoaders,
    getChartService,
    query.from,
    query.to,
  ]);

  useEffect(() => {
    getChartAdvisor();
  }, [getChartAdvisor]);

  return series.length && series[0] === -1 ? (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <CircularProgress color="primary" />
    </Grid>
  ) : series.length > 0 ? (
    <BarChartCustom
      series={series}
      yType="Reais"
      yFormatter={(value) => formatDecimal(value)}
      labelFormatter={(value) => formatCurrency(value)}
      isLoading={loaders.isAdvisorChartLoading}
    />
  ) : (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <NoData>Nada encontrado</NoData>
    </Grid>
  );
};

export default AdvisorChart;
